(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSplide(root) {
    var el = root.querySelector('[data-dgt-hero-splide]');
    if (!el || !window.Splide) return;
    var count = el.querySelectorAll('.splide__slide').length;
    var multi = count > 1;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dgt-hero-dot]'));
    var prev = root.querySelector('[data-dgt-hero-prev]');
    var next = root.querySelector('[data-dgt-hero-next]');

    var splide = new Splide(el, {
      // 'fade': crossfade between slides, paired with the CSS Ken Burns zoom on the active image
      // (dgt-hero.css). Requires the fade layout CSS in dgt-hero.css (the theme bundles Splide
      // core without it). Hero video is lazy-loaded separately.
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: false,
      drag: multi,
      autoplay: multi && root.dataset.autoplay !== 'false',
      interval: parseInt(root.dataset.interval, 10) || 6000,
      speed: 900,
      // Pausing is via the pause/play button (below), not hover — hover-pause is unreliable
      // (pauses but the resume is flaky) and impossible on touch.
      pauseOnHover: false,
      pauseOnFocus: false
    });

    function resetFills() {
      dots.forEach(function (d) {
        var f = d.querySelector('.dgt-hero__dot-fill');
        if (f) f.style.width = '0%';
      });
    }
    function setActive(i) {
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }

    splide.on('autoplay:playing', function (rate) {
      var active = dots[splide.index];
      if (!active) return;
      var f = active.querySelector('.dgt-hero__dot-fill');
      if (f) f.style.width = (rate * 100).toFixed(1) + '%';
    });
    splide.on('mounted move', function () {
      setActive(splide.index);
      resetFills();
    });

    if (prev) prev.addEventListener('click', function () { splide.go('<'); });
    if (next) next.addEventListener('click', function () { splide.go('>'); });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { splide.go(idx); });
    });

    splide.mount();

    // Tap / click the hero (anywhere but a link, button or form control) toggles pause &
    // resume — same gesture on desktop and touch, no button needed. A center play icon
    // (.dgt-hero--paused) signals the paused state.
    var manualPaused = false;
    el.addEventListener('click', function (e) {
      if (e.target.closest('a, button, [role="button"], input, select, textarea, label')) return;
      var ap = splide.Components.Autoplay;
      if (!ap) return;
      manualPaused = !manualPaused;
      if (manualPaused) { ap.pause(); } else { ap.play(); }
      root.classList.toggle('dgt-hero--paused', manualPaused);
    });
  }

  function addMagnet(el, strength) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var mx = Math.max(-10, Math.min(10, (e.clientX - r.left - r.width / 2) * strength));
      var my = Math.max(-8, Math.min(8, (e.clientY - r.top - r.height / 2) * strength));
      el.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
    });
    el.addEventListener('mouseleave', function () { el.style.transform = ''; });
  }

  function magnetic(root) {
    if (reduce) return;
    root.querySelectorAll('.dgt-hero__btn').forEach(function (el) { addMagnet(el, 0.12); });
    root.querySelectorAll('[data-dgt-magnet]').forEach(function (el) { addMagnet(el, 0.22); });
  }

  function init(root) {
    if (root.dataset.dgtHeroReady === '1') return;
    root.dataset.dgtHeroReady = '1';
    initSplide(root);
    magnetic(root);
  }

  function boot() { document.querySelectorAll('[data-dgt-hero]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dgt-hero]');
    if (root) init(root);
  });
})();
